import React, { Component } from 'react'
import PropTypes from 'prop-types'
import '../styles/hex.css'

class Hex extends Component {
  render () {
    return (
      <div className='hex'>
        <div className='number'>
          <span className='hash'>&#35;</span>
          <span className='list-number'>{this.props.number}</span>
        </div>
        <span>{this.props.text}</span>
      </div>
    )
  }
}

Hex.propTypes = {
  number: PropTypes.number.isRequired,
  text: PropTypes.string.isRequired
}

export default Hex



// WEBPACK FOOTER //
// ./src/components/Hex.js